/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Meta_TitleInputs */

const es_marketplace_seo_galicia_meta_title = /** @type {(inputs: Marketplace_Seo_Galicia_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquiler barco Galicia: Sálvora, Cíes y Rías Baixas | Zarpar`)
};

const gl_marketplace_seo_galicia_meta_title = /** @type {(inputs: Marketplace_Seo_Galicia_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alugueiro barco Galicia: Sálvora, Cíes e Rías Baixas | Zarpar`)
};

const en_marketplace_seo_galicia_meta_title = /** @type {(inputs: Marketplace_Seo_Galicia_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boat rental Galicia: Sálvora, Cíes & Rías Baixas | Zarpar`)
};

/**
* | output |
* | --- |
* | "Boat rental Galicia: Sálvora, Cíes & Rías Baixas \| Zarpar" |
*
* @param {Marketplace_Seo_Galicia_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_meta_title = /** @type {((inputs?: Marketplace_Seo_Galicia_Meta_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Meta_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_meta_title(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_meta_title(inputs)
	return es_marketplace_seo_galicia_meta_title(inputs)
});